import { Table, TableCell, TableBody, TableHead, TableRow, Checkbox, Grid, Tooltip, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import { useEffect, useState } from 'react';
import { invokeGetService, handleSnackBar, invokePostService, setInnerScreenRender, setReRender } from "../../../store/global/actions";
import CircularProgress from '@material-ui/core/CircularProgress';
import UpdateCancel from '../../atoms/buttons/UpdateCancel';
import { getDetailsFromUrl } from '../../../services/blueprint';

const useStyles = makeStyles(() => ({
    customTooltip: {
        minHeight: 50,
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center"  // ✅ horizontal centering for multiline text
    }
  }));

export default function DelegateSelector({ forwaredTransactions, type, testcaseId, isFetching, setIsFetching, selectedDelegates, setSelectedDelegates, onClose }) {
    const classes = useStyles();
    const { entityId } = getDetailsFromUrl()

    const dispatch = useDispatch();
    const [delegates, setDelegates] = useState([]);
    const [updatedDelegates, setUpdatedDelegates] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedTransactions, setSelectedTransactions] = useState(null)
    const [clusterletsInSelectedTransactions, setClusterletsInSelectedTransactions] = useState([])
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    const excludedDelegates = ['mysql_delegate'];
   
    useEffect(() => {
        if(selectedTransactions){
            setLoading(true);
            dispatch(invokeGetService('getClusterlets', {}))
                .then((response) => {
                    if (response.status && response.data) {
                        const clusterletsInSelectedTransactions = [];
                        selectedTransactions.forEach(element => {
                            element.clusterlets.forEach(cl => {
                                clusterletsInSelectedTransactions.push(cl.id);
                            })
                        });
                        setClusterletsInSelectedTransactions(clusterletsInSelectedTransactions)
                        setSelectedDelegates(selectedDelegates.filter(item =>  clusterletsInSelectedTransactions.includes(item._id)));
                        const delegatesInSelectedTransactions = response.data.filter(clusterlet => {
                            return clusterletsInSelectedTransactions.includes(clusterlet._id) && clusterlet.type === 1;
                        });
                        const filteredDelegates = delegatesInSelectedTransactions.filter(del => !excludedDelegates.includes(del?.attributes?.type));
                        setDelegates(filteredDelegates);
                    }
                    else {
                        dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
                    }
                    setLoading(false)

                });
        }
    }, [selectedTransactions]);



    useEffect(() => {
        if (type === "edit") {
          dispatch(invokeGetService('getTestcaseData', [testcaseId])).then((testcaseDetails) => {
            if (testcaseDetails.status == true) {
              const simulationTransactions = testcaseDetails?.data?.testcaseTransactions.map(item => {
                return { _id: item.transaction_id, simulationTransactionId: item._id, order: item.order };
              });
              simulationTransactions.sort((a, b) => a.order - b.order)
              const delegates = testcaseDetails?.data?.testcase?.delegates.map(item => {
                return { _id: item.id }
              });
              setUpdatedDelegates(delegates.filter(item =>  clusterletsInSelectedTransactions.includes(item._id)));
            }
          })
        }
      }, [type])


    useEffect(() => {
        if(selectedDelegates !== updatedDelegates && updatedDelegates?.length > 0){
            setSelectedDelegates(updatedDelegates)
        }
    },[updatedDelegates])

    useEffect(() => {
        if(testcaseId){
            setLoading(true)
            dispatch(invokeGetService('getTestcaseTransactions',[testcaseId]))
            .then((response) => {
                if(response.status && response.data){
                    setSelectedTransactions(response.data)
                }
            })
        }else{
            setSelectedTransactions(forwaredTransactions)
        }
    },[])

    const isNodeChecked = (node) => {
        const status = selectedDelegates.find(delegate => delegate._id == node._id);
        return status;
    }

    const onSelect = (node, isChecked) => {
        isChecked ? setSelectedDelegates([...selectedDelegates, node]) : setSelectedDelegates(selectedDelegates.filter(item => item._id != node._id));
    }

    const onTransactionUpdate = () => {
        setIsFetching(true)
        const delegates = selectedDelegates?.map(item => item._id);
        if (selectedDelegates.length < 1) {
            dispatch(handleSnackBar({ open: true, message: 'Must select atleast one delegate for simulation', severity: 'error' }));
            setIsFetching(false);
            return;
        }
        dispatch(invokePostService('updateDelegates',{delegates, testsuiteId: entityId}, [testcaseId]))
            .then(response => {
                setIsFetching(false);
                if (response.status && response.data !== null) {
                  dispatch(setInnerScreenRender());
                  dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
                  dispatch(setReRender())
                } else {
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
                }
          });
    }


    const handleMouseMove = (event) => {
        setMousePos({
        x: event.clientX,
        y: event.clientY,
        });
    };

    return (
        <Grid row xs={12}>

            <Grid>
                <Table id="delegate_selector_table" onMouseMove={handleMouseMove} >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell component="th"></StyledTableCell>
                            <StyledTableCell component="th">Name</StyledTableCell>
                            <StyledTableCell component="th">Description</StyledTableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {loading ?
                            <StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={6} component="td" style={{ padding: 15 }}>
                                    Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                </StyledTableCell>
                            </StyledTableRow>
                            : delegates.length < 1 ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={6} component="td" style={{ padding: 15 }}>
                                        No delegates available.
                                    </StyledTableCell>
                                </StyledTableRow>
                                :
                                <>
                                    {delegates.map(delegate => {
                                        const isController = delegate?.name === "Controller";
                                        const tooltipTitle = isController ? "Controller delegate is an internal delegate. Cannot simulate" : "";
                                        return (  

                                            <TableRow>
                                                    <Tooltip title={tooltipTitle} classes={{ tooltip: classes.customTooltip }}  placement="top-end" >
                                                        <TableCell component="td">
                                                                <span>
                                                                    <Checkbox color="primary" onChange={e => onSelect(delegate, e.target.checked)} checked={isNodeChecked(delegate)} disabled={isController} />
                                                                </span>
                                                        </TableCell>
                                                    </Tooltip>

                                                    <Tooltip title={tooltipTitle} classes={{ tooltip: classes.customTooltip }}  placement="top-end" >
                                                        <TableCell component="td">
                                                                <span> {delegate.name} </span> 
                                                        </TableCell>
                                                    </Tooltip>

                                                    <Tooltip title={tooltipTitle} classes={{ tooltip: classes.customTooltip }}  placement="top-end" >
                                                        <TableCell component="td">
                                                                <span> {delegate?.attributes?.desc} </span> 
                                                        </TableCell>
                                                    </Tooltip>
                                            </TableRow>
                                        
                                        )}
                                    )}
                                </>
                        }
                    </TableBody>
                </Table>
            </Grid>

            <Grid xs={12} style={{ justifyContent: 'flex-end', display: 'flex', paddingTop: '1rem' }}>
              {type === "edit" &&
                <UpdateCancel onUpdate={onTransactionUpdate} onCancel={onClose} updateDisable={isFetching} />
              }
            </Grid>

        </Grid>
    )
}